/* LWA_RECO — shared personalized ranking for quiz / companion / gifts / stylist.
   Fixes the "same listings every time" problem:
   - matches against cleaned display title + tags, not keyword-stuffed raw titles
   - seeded tie-break: same inputs → same set (stable), different inputs → different set
   - stem dedupe: never two near-identical variants of the same piece in one rail */
window.LWA_RECO = (function(){
  const stem = p => (p.dt || p.t.split('|')[0].split('—')[0].split('-')[0]).trim().toLowerCase();
  const hash = s => { let h = 2166136261; for(let i=0;i<s.length;i++){ h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; };
  const jitter = (p, seed, amp) => (hash(p.h + '|' + seed) % 1000) / 1000 * (amp == null ? .6 : amp);

  /* rank(cat, wordSets, opts)
     wordSets: [{words:[...], w:weight}, ...] — later sets layer onto earlier ones
     opts: {n, seed, minScore} */
  function rank(cat, wordSets, opts){
    opts = opts || {};
    const n = opts.n || 8, seed = opts.seed || 'lwa', minS = opts.minScore == null ? 1 : opts.minScore;
    const w = new Map();
    (wordSets || []).forEach(ws => (ws.words || []).forEach(x => {
      x = String(x).toLowerCase().trim(); if(x.length > 2) w.set(x, (w.get(x) || 0) + (ws.w || 1));
    }));
    const seen = new Set();
    return (cat || []).map(p => {
      let s = 0; const counted = new Set();
      ((p.dt || '') + ' ' + p.t + ' ' + (p.g || []).join(' ')).toLowerCase()
        .split(/[^a-z]+/).forEach(t => { if(!counted.has(t) && w.has(t)){ s += w.get(t); counted.add(t); } });
      return { p, s: s + jitter(p, seed) };
    }).filter(x => x.s >= minS && x.p.img)
      .sort((a,b) => b.s - a.s)
      .filter(x => { const st = stem(x.p); if(seen.has(st)) return false; seen.add(st); return true; })
      .slice(0, n).map(x => x.p);
  }
  return { rank, stem, hash, jitter };
})();
